<template>
  <aside
    ref="MainContent"
    class="fixed top-[102px] backdrop-blur-lg sm:px-10 px-5 pt-5 sm:pt-10 z-[29] transform overflow-x-hidden overflow-y-auto -left-full w-full bottom-0"
  >
    <div
      data-menu-card
      class="relative z-10 flex flex-col w-full px-10 py-10 mb-10 bg-white"
    >
      <ol class="flex-1 w-full mb-5">
        <li
          class="w-full"
          v-for="(item, item_index) in menu_list"
          :key="`item_${item_index}`"
        >
          <router-link
            :aria-label="item.title"
            class="block py-4 text-sm font-bold uppercase transition-all duration-300 border-zinc-300 text-zinc-500 hover:md:opacity-50"
            :class="
              item_index == menu_list.length - 1 ? 'border-b-0' : 'border-b'
            "
            :to="item.link"
            @click.native="$emit('toggle-menu')"
          >
            <span
              class="inline-block mr-5 text-xl uppercase sm:text-2xl text-primary"
              >{{ item.title }}</span
            >
            {{ item.sub_title }}
          </router-link>
        </li>
      </ol>

      <div class="flex items-center justify-center w-full">
        <router-link
          to="/apply_online/form"
          class="flex items-center justify-between w-full px-6 py-3 text-white sm:text-xl bg-primary"
        >
          立即試算
          <span class="block w-2 h-2 bg-white rounded-full"></span>
        </router-link>
      </div>
    </div>
    <div
      data-menu-card
      class="relative z-10 flex flex-col w-full px-10 py-10 bg-white"
    >
      <div class="mb-8">
        <p class="text-sm font-bold text-main_black">24小時服務專線</p>
        <h4 class="text-4xl font-black sm:text-5xl text-primary">
          {{ $GetColumn("company_phone") }}
        </h4>
      </div>

      <div class="flex items-center justify-center w-full">
        <a
          :href="`tel://${$GetColumn('company_phone')}`"
          target="_blank"
          class="flex items-center justify-between w-full px-6 py-3 text-white sm:text-xl bg-primary"
        >
          來電諮詢
          <span class="block w-2 h-2 bg-white rounded-full"></span>
        </a>
      </div>
    </div>

    <div
      data-menu-bg
      class="absolute top-0 bottom-0 left-0 right-0 z-0 bg-opacity-60 bg-primary"
    ></div>
  </aside>
</template>

<script>
import { MainMenu } from "@/gsap/MainMenu";
export default {
  name: "MainMenu",
  props: {
    menu_status: {
      require: true,
      type: Boolean,
    },
  },
  data() {
    return {
      menu_list: [
        {
          title: "產品介紹",
          sub_title: "Services",
          link: "/#Services",
        },
        {
          title: "服務流程",
          sub_title: "Flow",
          link: "/#Flow",
        },
        {
          title: "關於我們",
          sub_title: "About",
          link: "/about",
        },
        {
          title: "各大融資項目",
          sub_title: "Glossary",
          link: "/glossary",
        },
        {
          title: "常見問題",
          sub_title: "Question",
          link: "/question",
        },
      ],
      menu_gsap: null,
    };
  },
  watch: {
    menu_status() {
      if (this.menu_status) {
        this.menu_gsap.open();
      } else {
        this.menu_gsap.close();
      }
    },
  },
  mounted() {
    this.menu_gsap = new MainMenu(this.$refs.MainContent);
    this.menu_gsap.reset();
  },
};
</script>
